const details = (): void => {
  // TablePress
  addEventListener('load', () => {
    setTimeout(() => {
      const tablePresElements = document.querySelectorAll('.dataTable');
      console.log(tablePresElements);
      if (tablePresElements.length) {
        tablePresElements.forEach((element) => {
          console.log(element);
          // divタグで加工
          const div = document.createElement('div');
          div.className = 'table-responsive';
          element.parentNode?.replaceChild(div, element);
          div.appendChild(element);
        });
      }
    }, 300);
  });

  const galleryItems: NodeListOf<HTMLElement> = document.querySelectorAll('.wp-block-gallery .wp-block-image');
  if (galleryItems.length) {
    galleryItems.forEach((item) => {
      const caption: HTMLElement | null = item.querySelector('.wp-element-caption');
      const captionHeight = caption ? caption.clientHeight : 0;
      item.style.marginBottom = `${captionHeight}px`;
    });
  }
};

export default details;
